import { createRouter, createWebHistory, RouterView } from 'vue-router';

import { accessGuardMiddleware } from './middleware/accessGuard.middleware';
import { fetchAuthDataMiddleware } from './middleware/fetchAuthData.middleware';
import { loadLayoutMiddleware } from './middleware/loadLayout.middleware';
import { checkAuthMiddleware } from './middleware/checkAuth.middleware';
import { salesCrmAccessMiddleware } from './middleware/salesCrmAccess.middleware';
import { loyaltyProgramCheckMiddleware } from './middleware/loyaltyProgramCheck.middleware';
import { goToNewPointMiddlewar } from './middleware/goToNewPoint.middleware';
import { featureFlagMiddleware } from './middleware/featureFlag.middleware';
import { moduleAccessMiddleware } from './middleware/moduleAccess.middleware';
import { clearChunkLoadRecovery, recoverFromChunkLoadError } from './chunkLoadRecovery';

import i18n from '@/i18n';

import auth from './auth';
import catalog from './catalog';
import crm from './crm';
import broadcast from './broadcast';
import dashboard from './dashboard';
import errorAccess from './error';
import faq from './faq';
import loyalty from './loyalty';
import points from './points';
import staff from './staff';
import support from './support';
import profile from './profile';
import backOffice from './backOffice';
import salesCrm from './salesCrm';
import statistic from './statistic';
import integrations from './integrations';
import dev from './dev';
import { getAppModuleRegistry } from '@/modules';
// import wallet from "./wallet";
// import bankLinks from "./banks";
// import feedback from "./feedback";

const appModuleRegistry = getAppModuleRegistry();

const routes = [
  {
    path: '/',
    redirect: () => {
      return `/${process.env.VUE_APP_I18N_LOCALE}`;
    },
  },
  {
    path: '/:locale',
    // Use RouterView directly as the passthrough route component
    // to render nested children correctly without invalid template usage
    // component: {
    //   template: '<RouterView />',
    // },
    component: RouterView,
    beforeEnter: (to, from, next) => {
      const locale = Array.isArray(to.params.locale) ? to.params.locale[0] : to.params.locale;
      const supported_locales = process.env.VUE_APP_I18N_SUPPORTED_LOCALE.split(',');
      if (!supported_locales.includes(locale)) return next(`/${process.env.VUE_APP_I18N_LOCALE}`);

      setI18nLocale(locale);

      return next();
    },
    children: [
      ...auth,
      ...backOffice,
      ...salesCrm,
      ...crm,
      ...broadcast,
      ...catalog,
      ...dashboard,
      ...faq,
      ...loyalty,
      ...statistic,
      ...support,
      ...staff,
      ...points,
      ...profile,
      ...integrations,
      ...dev,
      ...appModuleRegistry.routes,
      ...errorAccess,
      // ...test,
      // ...wallet,
      // ...bankLinks,
      // ...feedback,
    ],
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: () => {
      return `/${process.env.VUE_APP_I18N_LOCALE}`;
    },
  },
];

function setI18nLocale(locale) {
  if (typeof i18n.global.locale === 'object') {
    i18n.global.locale.value = locale;
  } else {
    i18n.global.locale = locale;
  }

  if (typeof localStorage !== 'undefined') {
    localStorage.setItem('locale', locale);
  }
}

const router = createRouter({
  history: createWebHistory(process.env.VUE_APP_BASE_URL),
  mode: 'history',
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      const element = document.querySelector(to.hash);
      if (element) {
        return {
          selector: to.hash,
          behavior: 'smooth', // Добавляет плавный скролл
        };
      }
    }
    return savedPosition || { x: 0, y: 0 }; // По умолчанию
  },
});
router.onError((error) => {
  if (recoverFromChunkLoadError(error)) {
    return;
  }

  console.error(`[Router Error]`, error);
});

router.afterEach(() => {
  clearChunkLoadRecovery();
});

router.beforeEach(featureFlagMiddleware);
router.beforeEach(salesCrmAccessMiddleware);
router.beforeEach(checkAuthMiddleware);
router.beforeEach(moduleAccessMiddleware);
router.beforeEach(fetchAuthDataMiddleware);
router.beforeEach(accessGuardMiddleware);
router.beforeEach(loadLayoutMiddleware); // Not Closed!!!!!
router.beforeEach(loyaltyProgramCheckMiddleware);
router.beforeEach(goToNewPointMiddlewar);

export default router;
